import { Component, OnInit } from '@angular/core';
import { NetLossesService } from './net-losses.service';
import { DataTypeComponent } from '../../data-type-component';
import { NetLossesDTO } from './net-losses.model';
import { ActivatedRoute } from '@angular/router';
import { filter, map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-net-losses',
  templateUrl: './net-losses.component.html',
  styleUrls: ['./net-losses.component.scss'],
  standalone: false,
})
export class NetLossesComponent extends DataTypeComponent {
  netLosses: NetLossesDTO;
  constructor(
    private service: NetLossesService,
    private route: ActivatedRoute
  ) {
    super();
  }

  override setRowData(entity: any) {
    this.route.parent.params
      .pipe(
        filter((p) => p.entityId),
        map((p) => p.entityId),
        switchMap((pid) => this.service.get(pid))
      )
      .subscribe((d) => (this.netLosses = d));
  }
}
